import { render, staticRenderFns } from "./EducationProtocolTableItem.vue?vue&type=template&id=e4d7cf3a&scoped=true&"
import script from "./EducationProtocolTableItem.vue?vue&type=script&lang=ts&"
export * from "./EducationProtocolTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./EducationProtocolTableItem.vue?vue&type=style&index=0&id=e4d7cf3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d7cf3a",
  null
  
)

export default component.exports